import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// API Service for Profind.ca

// Authentication
export const authAPI = {
  register: async (userData) => {
    const response = await axios.post(`${API}/auth/register`, userData);
    return response.data;
  },
  
  login: async (credentials) => {
    const response = await axios.post(`${API}/auth/login`, credentials);
    return response.data;
  }
};

// Service Categories
export const categoriesAPI = {
  getAll: async () => {
    const response = await axios.get(`${API}/categories`);
    return response.data;
  }
};

// Service Providers
export const providersAPI = {
  getAll: async (params = {}) => {
    const response = await axios.get(`${API}/providers`, { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axios.get(`${API}/providers/${id}`);
    return response.data;
  },
  
  create: async (providerData) => {
    const response = await axios.post(`${API}/providers`, providerData);
    return response.data;
  }
};

// Reviews
export const reviewsAPI = {
  getAll: async (providerId = null) => {
    const params = providerId ? { providerId } : {};
    const response = await axios.get(`${API}/reviews`, { params });
    return response.data;
  },
  
  create: async (reviewData) => {
    const response = await axios.post(`${API}/reviews`, reviewData);
    return response.data;
  }
};

// Quote Requests
export const quotesAPI = {
  create: async (quoteData) => {
    const response = await axios.post(`${API}/quotes`, quoteData);
    return response.data;
  },
  
  getAll: async (providerId = null) => {
    const params = providerId ? { providerId } : {};
    const response = await axios.get(`${API}/quotes`, { params });
    return response.data;
  },
  
  updateStatus: async (quoteId, status) => {
    const response = await axios.patch(`${API}/quotes/${quoteId}/status?status=${status}`);
    return response.data;
  }
};

// Testimonials
export const testimonialsAPI = {
  getAll: async () => {
    const response = await axios.get(`${API}/testimonials`);
    return response.data;
  }
};

export default {
  auth: authAPI,
  categories: categoriesAPI,
  providers: providersAPI,
  reviews: reviewsAPI,
  quotes: quotesAPI,
  testimonials: testimonialsAPI
};
